(() => {
  const styleWhatsAppButton = () => {
    const host = document.querySelector('gty-whatsapp-chat-button');
    const root = host?.shadowRoot;

    if (!root || root.querySelector('[data-briora-whatsapp-style]')) return false;

    const style = document.createElement('style');
    style.dataset.brioraWhatsappStyle = '';
    style.textContent = `
      @media (max-width: 749px) {
        .gty-wacb-button {
          width: 48px !important;
          height: 48px !important;
        }

        .gty-wacb-button svg {
          width: 24px !important;
          height: 24px !important;
        }
      }
    `;
    root.append(style);
    return true;
  };

  const observer = new MutationObserver(() => {
    if (styleWhatsAppButton()) observer.disconnect();
  });

  if (!styleWhatsAppButton()) {
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
